import { string, z } from "zod";

// extraFields lets a form validate more than the two password fields with the same rules
export function passwordMatcher(t, extraFields = {}) {
  return z
    .object({
      ...extraFields,
      password: string().min(8, { message: t("PasswordMustHave") }),
      confirmPassword: string().min(8, { message: t("PasswordMustHave") }),
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: t("PasswordNotMatched"),
      path: ["confirmPassword"],
    });
}
